import { DialogContent as MuiIDialogContent, DialogContentProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { DialogContentProps };

export const DialogContent: React.ComponentType<DialogContentProps> = styled(
  MuiIDialogContent,
)<DialogContentProps>(() => ({
  padding: '0 24px',
  display: 'flex',
  flexDirection: 'column',
}));
